import styled from "styled-components";

export const FreeSpace = styled.div`
  flex-grow: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
